<div class="flex flex-col items-center h-full">
  <div class="mt-32 text-4xl">404 - Not Found</div>
  <div class="flex items-center my-20">
    <label class="text-7xl">¯\_(ツ)_/¯</label>
  </div>
  <p class="text-lg w-2/5 text-center">We could not find the page you are looking for.</p>
</div>
